import React, { Component } from 'react';
// import '../../../containers/AdminConfig/js/AdminConfig';

class SideBarToggle extends Component {
    render() {
        return (
            <div style={{position: 'fixed',zIndex:1}}>
                <button type="button" id="sidebarAdminCollapse" className="btn btnSideBarToggle">
                    <i className="fa fa-chevron-left" />
                    <i className="fa fa-chevron-right" />
                </button>
                {/* <div className="embed-responsive embed-responsive-16by9"> */}
                    {/*<iframe className="embed-responsive-item" src="userInfo.html" allowFullScreen />*/}
                {/* </div> */}
            </div>
        );
    }
}

export default SideBarToggle;



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/SideBarToggle.js